import { gql } from '@apollo/client';

export const GET_PORTFOLIO_CUSTOMER_LEVEL_DETAILS = gql`
  query GetPortfolioCustomerLevelDetails($portfolioCodes: [String!], $take: Int) {
    portfolioCustomerLevelDetails(portfolioCodes: $portfolioCodes, take: $take) {
      bakerFedID
      portfolioCode
      assignedBrokers
      institutionName
      permissions {
        bba
        apm
        bsm
        irrm
        irrmReporting
        offerings
        dailyPricing
        dailyPricingItemLimit
      }
    }
  }
`;
